/**
 * An ISO 639-1 locale for which translations are available.
 */
enum Locale {
    en = "en",
    es = "es",
    fr = "fr"
}

export { Locale };
